var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"license-create"}},[_c('div',{staticClass:"container page"},[_c('license-create-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }